import React from 'react';
import './css/statistic.css';
import QaNavBox from '../components/QaNavbox';
import StatisticData, { StatisticItem, RangeData, LocationData } from '../components/StatisticData';

const totalEntries = StatisticData.length;
const overallTotal = StatisticData.reduce((sum, stat: StatisticItem) => {
    return sum + parseInt(stat.total.replace(/,/g, ''));
}, 0);

const Statistic: React.FC = () => {
    return (
        <div className="statistic-page-container">
            <QaNavBox />
            <div className="statistic-content-area">

                {/* Visual Header with Stats */}
                <div className="statistic-visual-header">
                    <div className="header-main">
                        <div className="title-section">
                            <h1>📊 Машины зорчих статистик</h1>
                            <p>Төрөл бүрийн газар нутагт зорчих машины тооны мэдээлэл</p>
                        </div>
                        <div className="header-stats">
                            <div className="stat-badge">
                                <span className="stat-number">{totalEntries}</span>
                                <span className="stat-label">Статистик</span>
                            </div>
                            <div className="stat-badge primary">
                                <span className="stat-number">{overallTotal.toLocaleString()}</span>
                                <span className="stat-label">Нийт зорчигч</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Statistics Grid */}
                <div className="statistic-grid">
                    {StatisticData.map((statistic: StatisticItem, index: number) => (
                        <StatisticCard
                            key={statistic.id}
                            {...statistic}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export interface StatisticCardProps extends Omit<StatisticItem, 'id'> {
    id: string;
    index: number;
}

export const StatisticCard: React.FC<StatisticCardProps> = ({
    title,
    location,
    type,
    data,
    total,
    year,
    index
}) => {
    const getTypeColor = () => {
        switch (type) {
            case 'range': return '#e74c3c';
            case 'location': return '#007bff';
            default: return '#9b59b6';
        }
    };

    const getTypeGradient = () => {
        switch (type) {
            case 'range': return 'linear-gradient(135deg, #e74c3c, #c0392b)';
            case 'location': return 'linear-gradient(135deg, #007bff, #0056b3)';
            default: return 'linear-gradient(135deg, #9b59b6, #8e44ad)';
        }
    };
    const renderDataPreview = () => {
        switch (type) {
            case 'range':
                const rangeData = data as RangeData[];
                const rangeTotal = rangeData.reduce((sum, item) => sum + item.AverageMonth, 0);

                return (
                    <div className="data-preview">
                        <div className="preview-stats">
                            <div className="preview-stat">
                                <span className="stat-value">{rangeData.length}</span>
                                <span className="stat-label">сар</span>
                            </div>
                            <div className="preview-stat">
                                <span className="stat-value">{(rangeTotal / rangeData.length).toLocaleString()}</span>
                                <span className="stat-label">дундаж/сар</span>
                            </div>
                        </div>
                        <div className="range-display">
                            {rangeData.map((item, i) => (
                                <div key={i} className="range-item">
                                    <span className="range-month">{item.month}</span>
                                    <span className="range-value">{item.MonthlyRange}</span>
                                    <span className="range-total">{item.AverageMonth.toLocaleString()}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                );

            case 'location':
                const locationData = data as LocationData[];

                return (
                    <div className="data-preview">
                        <div className="preview-stats">
                            <div className="preview-stat">
                                <span className="stat-value">{locationData.length}</span>
                                <span className="stat-label">байршил</span>
                            </div>
                        </div>
                        <div className="location-display">
                            {locationData.map((item, i) => (
                                <div key={i} className="location-item">
                                    <span className="location-name">{item.location}</span>
                                    <span className="location-value">{item.MonthlyRange}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div
            className="statistic-card"
            style={{
                '--type-color': getTypeColor(),
                '--type-gradient': getTypeGradient(),
                '--animation-delay': `${index * 0.1}s`
            } as React.CSSProperties}
        >
            <div className="card-glow"></div>

            <div className="card-content">
                <div className="card-title-section">
                    <h3 className="card-title">{title}</h3>
                    <div className="location-year">
                        <span className="location">
                            <span className="location-icon">📍</span>
                            {location}
                        </span>
                        <span className="year-badge">{year} он</span>
                    </div>
                </div>
                {renderDataPreview()}
            </div>

            <div className="card-footer">
                <div className="total-display">
                    <span className="total-label">Жилийн нийт зорчигч</span>
                    <span className="total-value">{total}</span>
                </div>
            </div>
        </div>
    );
};

export default Statistic;